import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import SysAdminRoleTableContainer from '../containers/sysadmin-role-table.container';
import SysAdminRoleDetailsContainer from '../containers/sysadmin-role-details.container';
import SysAdminRoleCreateContainer from '../containers/sysadmin-role-create.container';
import SysAdminRoleUpdateContainer from '../containers/sysadmin-role-update.container';
import {
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGINATION_PAGE,
} from '../../../../../const/default-paginated-table-data.const';

// Helper function to add default query parameters to the role list page
const SysAdminRoleListWithParams = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // Set default params if they don't exist
  if (!params.has('page')) {
    params.set('page', DEFAULT_PAGINATION_PAGE.toString());
  }
  if (!params.has('limit')) {
    params.set('limit', DEFAULT_PAGINATION_LIMIT.toString());
  }

  // If query params need to be added
  if (location.search !== `?${params.toString()}`) {
    return <Navigate to={`?${params.toString()}`} replace />;
  }

  return <SysAdminRoleTableContainer />;
};

export const sysAdminRoleRoutes = [
  {
    path: 'admin/role',
    element: <SysAdminRoleListWithParams />,
  },
  {
    path: 'admin/role/create',
    element: <SysAdminRoleCreateContainer />,
  },
  {
    path: 'admin/role/:id',
    element: <SysAdminRoleDetailsContainer />,
  },
  {
    path: 'admin/role/:id/update',
    element: <SysAdminRoleUpdateContainer />,
  },
];

export default sysAdminRoleRoutes;
